import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { FooterComponent } from "../footer/footer.component";
import { HeaderComponent } from "../header/header.component";
import { SidebarComponent } from "../sidebar/sidebar.component";
import { SidebarService } from "../sidebar/sidebar.service";

@Component({
    selector: "kno2-home",
    imports: [HeaderComponent, SidebarComponent, FooterComponent, RouterOutlet],
    templateUrl: "./home.component.html"
})
export class HomeComponent {
    private readonly sideBarService = inject(SidebarService);

    protected readonly sidebarCollapsed = this.sideBarService.collapsed;
}
